// What the AI read as the supplier on this document, for the admin's review
// screen: the name and ח.פ. as printed (documents.ocr_supplier_*, never
// edited) and, when the upload recognised the supplier itself, how
// (documents.ocr_matched_by — server/lib/supplierMatch.js MATCH_BY).
//
// "זוהה לפי" is shown only while the chosen supplier is still the one the
// upload matched: a supplier picked by hand afterwards was not recognised by
// anything, and older documents carry no reason at all.

const MATCH_BY_LABEL = {
  name: 'שם הספק',
  alias: 'שם כינוי + ח.פ.',
  business_id: 'ח.פ. + שם דומה',
};

/**
 * @param {object} doc  the document as GET /documents/:id returns it
 * @param {string|number|null} supplierId  the supplier currently chosen on the form
 * @returns {{name:string|null, businessId:string|null, matchedBy:string|null}|null}
 *          null when the document has no read to show
 */
export function ocrSupplierRead(doc, supplierId) {
  const name = (doc?.ocr_supplier_name || '').trim() || null;
  const businessId = doc?.ocr_supplier_business_id || null;
  if (!name && !businessId) return null;
  const sameSupplier = doc.ocr_matched_supplier_id != null
    && supplierId != null && supplierId !== ''
    && Number(supplierId) === Number(doc.ocr_matched_supplier_id);
  const matchedBy = sameSupplier ? (MATCH_BY_LABEL[doc.ocr_matched_by] || null) : null;
  return { name, businessId, matchedBy };
}
